import {
  ISelectedImage,
  SELECT_IMAGES,
  UPLOAD_IMAGE_REQUEST,
  UPLOAD_IMAGE_SUCCESS,
  UPLOAD_IMAGE_FAILURE,
  REMOVE_IMAGE,
  RESET_IMAGES,
} from './actions';

export interface DataState {
  selectedImages: ISelectedImage[];
}

const initialState: DataState = {
  selectedImages: [] as ISelectedImage[],
};

const UploadReducer = (
  state: DataState = initialState,
  action: any,
): DataState => {
  switch (action.type) {
    // select image
    case SELECT_IMAGES: {
      let newImage = [...state.selectedImages];
      if (!Array.isArray(action.payload)) {
        const index = newImage.findIndex((e: any) => 
          e.name === action.payload.name
        )
        if (index === -1) {
          newImage.push(action.payload)
        } else {
          newImage[index] = action.payload
        }
      } else {
        newImage = [
          ...state.selectedImages,
          ...action.payload,
        ]
      }
      newImage = newImage.map((file: any) => ({
        ...file,
        uploading: !file?.url?.medium || !file?.url?.thumbnail,
        src: file?.url?.medium || file?.url?.thumbnail || '',
        error: null,
      }));
      return {
        ...state,
        selectedImages: newImage,
      };
    }
    case UPLOAD_IMAGE_REQUEST:
      return {
        ...state,
        selectedImages: state.selectedImages.map((img: any) =>
          img.uuid === action.payload.uuid
            ? { ...img, uploading: true, error: null }
            : img
        ),
      };
    case UPLOAD_IMAGE_SUCCESS:
      return {
        ...state,
        selectedImages: state.selectedImages.map((img: any) =>
          img.uuid === action.payload.uuid
            ? {
                ...img,
                ...action.payload,
                uploading: false,
                src: action.payload?.url?.medium || action.payload?.url?.thumbnail,
              }
            : img
        ),
      };
    case UPLOAD_IMAGE_FAILURE: {
      return {
        ...state,
        selectedImages: state.selectedImages.map((img: any) =>
          img.uuid === action.payload.file.uuid
            ? { ...img, uploading: false, error: action.payload.error || 'upload error' }
            : img
        ),
      };
    }
    case REMOVE_IMAGE: {
      return {
        ...state,
        selectedImages: state.selectedImages.filter((img: any) => img.uuid !== action.payload.uuid),
      };
    }
    case RESET_IMAGES:
      return {
        ...state,
        selectedImages: [],
      };
    default:
      return state;
  }
};

export default UploadReducer
